import { API_URL } from './config';
import token from './Token';

export const fetchGanttData = async (signal) => {
    const read = async (path) => {
        const response = await fetch(`${API_URL}${path}?token=${encodeURIComponent(token || '')}`, { signal });
        if (!response.ok) throw new Error('Could not load the timeline. Please try again.');
        const payload = await response.json();
        if (payload?.error) throw new Error('Could not load the timeline. Please try again.');
        return payload;
    };
    // Full collections: Day Preview's time buckets need not contain every future item.
    const [tasks, todos] = await Promise.all([read('/subtasks'), read('/todoChangeTargets')]);
    if (!Array.isArray(tasks) || !Array.isArray(todos?.todos)) throw new Error('The timeline received an unexpected data format.');
    return { tasks, todos: todos.todos, todoVersion: todos.version || 0 };
};

const mutationEndpoint = {
    task: '/applyTaskChanges',
    subtask: '/applySubtaskChanges',
    subsubtask: '/applySubsubtaskChanges',
    todo: '/applyTodoChanges',
};

export const applyGanttDateChange = async (row, set) => {
    const identity = row.identity || {};
    const change = {
        changeId: `gantt-${Date.now()}`,
        operation: 'update',
        expectedVersion: row.version,
        set,
        ...(row.kind === 'task' ? { practicalId: identity.taskPracticalId } : {}),
        ...(row.kind === 'subtask' ? { taskPracticalId: identity.taskPracticalId, sn: identity.sn } : {}),
        ...(row.kind === 'subsubtask' ? { taskPracticalId: identity.taskPracticalId, subtaskSn: identity.subtaskSn, sn: identity.sn } : {}),
        ...(row.kind === 'todo' ? { todoId: identity.todoId } : {}),
    };
    const response = await fetch(`${API_URL}${mutationEndpoint[row.kind]}?token=${encodeURIComponent(token || '')}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // One change touches one MongoDB document, so it is already atomic and
        // does not require transaction support from the deployment.
        body: JSON.stringify({ atomic: false, changes: [change] }),
    });
    const payload = await response.json().catch(() => null);
    const result = payload?.results?.[0];
    if (!response.ok || payload?.error || payload?.status !== 'applied' || result?.status !== 'applied') {
        throw new Error(payload?.error?.message || result?.error?.message || 'Could not save the timeline change.');
    }
    return result;
};
